import React from 'react';
import './showWarn.less';
import { withRouter } from 'react-router-dom';
import { systemConfig,getZkShopName,getTaoteShopName } from '../../utils/http';

class ShowWarn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isShow: props.isShow,
            alibabaNickName:props.alibabaNickName,
            taoteNickName:props.taoteNickName,
            from_action: props.from_action
        };
        setTimeout(()=>{ 
            this.state.alibabaNickName = getZkShopName();
            this.state.taoteNickName = getTaoteShopName();
            this.state.from_action = systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' :null;
            this.setState({ });
        },2000);
    }
    componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数
        this.setState({
            isShow:props.isShow,
        })
    }

    targetUrl=()=>{
        // this.props.targetUrl("/myAuth")
        const path = { pathname: '/myAuth', state: { from_action: this.state.from_action } }
        this.props.history.push(path);
    }

    render() {
        let elems = null;
        elems =
            this.state.isShow ?
                <div className='warnWrap'>
                    <i>!</i>
                    <span>当前店铺未授权1688货源账号，为了不影响您的正常铺货采购，</span>
                    <s onClick={()=>this.targetUrl()}>请点我开始授权</s>
                </div> : 
            this.state.from_action == "alibaba_auth_expire" ? 
            <div className='warnWrap'>
                    <i>!</i>
                    <span>1688货源账号【{this.state.alibabaNickName}】授权已经失效，</span>
                    <s onClick={()=>this.targetUrl()}>请点我开始授权</s>
                </div> :
            this.state.from_action == "taote_auth_expire" ? 
            // <div className='warnWrap'>
            //         <i>!</i>
            //         <span>淘特货源账号【{this.state.taoteNickName}】授权已经失效，</span>
            //         <s onClick={()=>this.targetUrl()}>请点我开始授权</s>
            //     </div> 
            null
                :null
        return (
            elems
        );
    }
}

export default withRouter(ShowWarn);



// WEBPACK FOOTER //
// ./src/components/showWarn/showWarn.jsx